import { render, staticRenderFns } from "./DialogHistorico.vue?vue&type=template&id=18a2652e"
import script from "./DialogHistorico.vue?vue&type=script&lang=js"
export * from "./DialogHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports